import React from "react";

type GridRowProps = React.PropsWithChildren<{
    style?: React.CSSProperties;
}>;

export const GridRow: React.FunctionComponent<GridRowProps> = (props: GridRowProps) => {
    return (
        <div className="ms-Grid-row" style={props.style}>
            {props.children}
        </div>
    );
};
